import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { adoptPrerenderedHead } from "./lib/prerenderedHead";
import "./index.css";

// The prerendered pages ship a crawlable static copy of the page as a SIBLING of
// #root (see scripts/prerender-og.mjs). Remove it synchronously, before React
// mounts, so a visitor never sees both copies and React never hydrates it.
document.getElementById("prerender-body")?.remove();

// The prerendered head tags stay until react-helmet renders its own, then go:
// one description, one canonical and one set of og:* tags, never two.
adoptPrerenderedHead();

createRoot(document.getElementById("root")!).render(<App />);
